import request from '@/utils/request'


export function getList () {
  return request({
    url: '/api/wallet/index',
    method: 'get'
  })
}

export function getInfo (params) {
  return request({
    url: '/api/wallet/getInfo',
    method: 'get',
    params
  })
}


/**
 * 添加或编辑
 * @param params
 * @returns
 */
export function addOrUpdate(params) {
  return request({
    url: '/api/wallet/addOrUpdate',
    method: 'POST',
    params
  })
}

/**
 * 删除
 * @param params
 * @returns
 */
export function deleteWallet(params) {
  return request({
    url: '/api/wallet/deleteWallet',
    method: 'POST',
    params
  })
}
